/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/indent */
import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { AnyObject } from "../../../../shared/types/app.type";
import { UserInfo } from "../../../../shared/types/user-info";
import { createStateField } from "../location";
import { LocationService } from "../location.service";
import { Location as LocationInterface } from "../location.type";
import { CreateLocationService } from "./create-locations.service";

@Component({
  selector: "app-create-locations",
  templateUrl: "./create-locations.component.html",
  styleUrls: ["./create-locations.component.css"],
  providers: [CreateLocationService],
})
export class CreateLocationsComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  currentUser: UserInfo;
  createLocationsForm: FormGroup;
  questions: AnyObject;

  constructor(
    public location: Location,
    private router: Router,
    private locationService: LocationService,
    private questionsService: CreateLocationService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit(): void {
    this.questionsService
      .generateQuestions({
        ...(this.currentUser.isCompany() && {
          companyValue: this.currentUser.selectedCompanyId || this.currentUser.companyId,
          companySkip: true,
          partnerSkip: true,
          isChannelWorksSkip: true,
          specialInstructionsSkip: true,
          ...(this.currentUser.hasManyCompanies() && {
            companySkip: false,
            partnerValue: this.currentUser.company.partnerId,
            companyEdit: false,
          }),
        }),
        ...(this.currentUser.isPartner() && {
          partnerValue: this.currentUser.partnerId,
          partnerSkip: true,
          isChannelWorksSkip: true,
          specialInstructionsSkip: true,
        }),
        currentUser: this.currentUser,
      })
      .subscribe((qs) => {
        this.questions = qs;
      });
  }

  goBack(): void {
    this.location.back();
  }

  onChange(event: AnyObject): void {
    if (event.source.id === "countryId") {
      this.dynamicForm.replaceOrAppendQuestion(createStateField(event.source.value));
      this.dynamicForm.form.controls["state"].setValue(undefined);
    }
  }

  navigateToBulkMode(): void {
    this.router.navigate(["/locations/bulk-upload"]);
  }

  onSubmit(values: LocationInterface): void {
    for (const propName in values) {
      if (values[propName] === "") {
        delete values[propName];
      }
    }

    this.locationService
      .createLocation({
        ...values,
      })
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (location: LocationInterface) => {
          this.notificationService.success("Location successfully created");
          this.router.navigate([`/locations/${location.id}`], {
            queryParams: {
              assets_filter: "coverageStatus",
              assets_value: "active",
              assets_page: 1,
            },
          });
        },
        (error) => {
          this.notificationService.error(error);
        },
      );
  }
}
